import $store from "../store/store";
import $http from "./http";
import $api from "./api";
import $config from "./config";
import $common from "./common";
import {
    Message
} from 'element-ui';

export default {
    http(url, _obj = null, mode = 'post', cb = null, isload = false, receipt = false) {
        $http[mode](url, _obj, isload).then(res => {
            if (receipt) {
                cb && cb(res);
            } else {
                if (res.code == 0) {
                    cb && cb(res.data);
                } else {
                    Message.error(res.msg || '请求失败');
                }
            }
        })
    },
    getBank() { //获取银行卡列表
        this.http($api.banklist, null, 'get', data => {
            $store.commit("setBankArr", data);
        });
    },
    getUserInfo() { //获取个人信息
        this.http($api.members + '/' + $common.getUser().user_id, null, 'get', data => {
            $store.commit("updataUserInfo", data);
            // this.autoJoinAct(data.userId)
            this.getvipdata();
            this.getuserMoney();
        });
    },
    getuserMoney(cb = null, isload = false, receipt = false) { //获取总余额 and 余额列表
        let _obj = {
            clientId: $store.getters.userInfo.clientId,
            clientIp: $config.clientIp,
            memberId: $store.getters.userInfo.userId,
            username: $store.getters.userInfo.name
        };
        this.http($api.getuserMoney, _obj, 'post', data => {
            let _data = data;
            if (receipt) _data = data.data;
            $store.commit("updataUserInfo", _data);
            cb && cb(data);
        }, isload, receipt);
    },
    getvipdata() { //获取会员信息
        this.http($api.getvipdata + $store.getters.userInfo.levelId, null, 'get', data => {
            $store.commit("updataUserInfo", {
                viplv: data.gradeId
            });
        });
    },
    oneKeyBalance() { //一键归集
        let _obj = {
            clientId: $store.getters.userInfo.clientId,
            clientIp: $config.clientIp,
            memberId: $store.getters.userInfo.userId,
            username: $store.getters.userInfo.name
        };
        this.http($api.oneKeyBalance, _obj, 'post', data => {
            Message.success("归集成功");
            this.getuserMoney();
        });
    },
    // 自动参与活动
    // autoJoinAct(id) {
    //     let params = {
    //         memberId: id
    //     };
    //     this.http($api.autoJoinAct, params, 'putUrl', data => {
    //         console.log(data)
    //     });
    // },
}